import React from 'react';
import './CreateChat.scss';
import ChatCreateForm from "../../components/layout/ChatCreateForm/ChatCreateForm";
import VerifyEmailCard from "../../components/layout/VerifyEmail/VerifyEmailCard";
import {useProfileStore} from "../../store/profile/pofile.store";

const CreateChat = () => {
    const {user}: any = useProfileStore();

    // The backend only creates chats for verified emails, so ask before people fill in the whole wizard
    return (
        <div className="ChatCreateForm__page">
            {user && !user.verified ? <VerifyEmailCard/> : <ChatCreateForm/>}
        </div>
    );
};

export default CreateChat;
